import { observable } from 'mobx';

import { FetchOptions, SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { VirtualAgentCheckoutStatus, VirtualAgentFlightCheckout } from '__generated__/api';
import { RequestOptions } from 'bernie-graphql';
import analyticsWrapper from 'utility/analytics-wrapper';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { BaseBexApiStore } from 'stores/bex-api-store';

export class VirtualAgentFlightCheckoutStore extends BaseBexApiStore {
  @observable public flightCheckoutInput: VirtualAgentFlightCheckout.Variables;
  public responseStatus: string;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const query = fetchOptions.query;
    const journeyContinuationId = query?.journeyContinuationId;
    const opaqueToken = query?.opaqueToken;
    const itineraryNumber = query?.itineraryNumber;
    this.flightCheckoutInput.flightsDetailsCriteria.journeyContinuationId = journeyContinuationId;
    this.flightCheckoutInput.virtualAgentContext.opaqueToken = opaqueToken;
    this.flightCheckoutInput.virtualAgentContext.itineraryNumber = itineraryNumber;
  }

  public fetchResults(
    virtualAgentVariable: VirtualAgentFlightCheckout.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<VirtualAgentCheckoutStatus> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = VirtualAgentFlightCheckoutStore.addClientInfoHeader(
      this.bexApiSource.headers,
      appName,
      region
    );

    return this.bexApiSource.operations
      .virtualAgentFlightCheckout(virtualAgentVariable, options)
      .then(response => {
        analyticsWrapper.publishAnalyticsPayload(response, analytics);
        const { status } = response?.data?.virtualAgentFlightCheckout ?? {};

        return status;
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'VIRTUAL_AGENT_FLIGHT_CHECKOUT'), error);

        return null;
      });
  }

  private static addClientInfoHeader(headers, appName, region) {
    return {
      ...headers,
      'Client-Info': `${appName},latest,${region ?? 'external'}`
    };
  }
}

VirtualAgentFlightCheckoutStore.DEFAULTS = {
  responseStatus: null,
  flightCheckoutInput: {
    flightsDetailsCriteria: {
      journeyContinuationId: 'test'
    },
    virtualAgentContext: {
      itineraryNumber: 'test',
      opaqueToken: 'test'
    }
  }
};
